import { GetDailyCheckInResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDailyCheckIn } from '../../services'
import { DailyCheckInQueryKeys } from '@/modules/promotion/keys'
import { GetDailyCheckInRequest } from '@/modules/promotion/type'
export default function useQueryGetDailyCheckIn(
	payload: GetDailyCheckInRequest,
	props?: UseBaseQueryOptions<GetDailyCheckInResponse>,
) {
	return useQuery({
		queryKey: [DailyCheckInQueryKeys.GetDailyCheckIn, payload],
		queryFn: () => getDailyCheckIn(payload),
		...props,
	})
}
